<template>
	<div name="old-poll">
		<template v-for="poll in oldPolls.rows">
			<template v-if="!poll.hasImage">
				<div class="box-poll">
					<div class="topic">
						{{ poll.topic }}
					</div>
					<template v-for="choice in poll.choices">
						<div class="choice dash-bg-color-skin-light-10">
						    <div class="progress dash-bg-color-skin-dark-10" :style="{ width: progressPercent(choice.number, poll.totalVote) }">
							</div>
							<div class="choosentext">
								<div class="choose-space">
									<i class="fa fa-check" v-show="choice.selected"></i>
								</div>
								<div class="text">{{ choice.text }}</div>
								<div class="number">{{ choice.number }}</div>
							</div>
						</div>
					</template>

					<div class="date-box">
						<i class="fa fa-thumbs-o-up like" aria-hidden="true"></i>
						<div class="total-vote">{{ poll.totalVote }}</div>
						<div class="date-poll">{{ poll.dtestrt }} - {{ poll.dteend }}</div>
						<i class="fa fa-clock-o clock" aria-hidden="true"></i>
					</div>
				</div>
			</template>

			<template v-else>
				<div class="box-poll-pic">
					<div class="topic">
						{{ poll.topic }}
					</div>
					<template v-for="choice in poll.choices">
						<div class="choice-img">
							<div class="set-img">
			                  <template v-if="choice.image">
			                    <img class="img-circle" :src="baseURL + filePath.load + choice.image">
			                  </template>
			                  <template v-else>
			                    <img class="img-circle" src="~static/images/employee/no_image.png">
			                  </template>
							</div>
							<div class="progress-bg dash-bg-color-skin-light-10">
							    <div class="progress dash-bg-color-skin-dark-10" :style="{ width: progressPercent(choice.number, poll.totalVote) }">
								</div>
								<div class="choosentext">
									<div class="choose-space">
										<i class="fa fa-check" v-show="choice.selected === 'Y'"></i>
									</div>
									<div class="text">{{ choice.text }}</div>
									<div class="number">{{ choice.number }}</div>
								</div>
							</div>
						</div>
					</template>
					<div class="date-box">
						<i class="fa fa-thumbs-o-up like" aria-hidden="true"></i>
						<div class="total-vote">{{ poll.totalVote }}</div>
						<div class="date-poll">{{ poll.dtestrt }} - {{ poll.dteend }}</div>
						<i class="fa fa-clock-o clock" aria-hidden="true"></i>
					</div>
				</div>
			</template>
		</template>
		<hrms-infinite-loading v-if="triggerOldPollInfiniteBool" @infinite="onInfinite" ref="oldPollsLoading" />
	</div>
</template>

<script>
import * as types from 'store/modules/poll/mutation-types'
import env from 'src/../env.js'

export default {
  name: 'old-poll',
  props: [ 'oldPolls', 'progressPercent', 'receivedOldPollsInfiniteLoading', 'triggerOldPollInfiniteBool', 'triggerOldPollResetBool', 'filePath' ],
  data () {
    return {
      page: 1,
      limit: 10,
      baseURL: window.localStorage.getItem(env.site + '_baseURL') + 'file_uploads/'
    }
  },
  created () {
    this.$store.commit(types.RESET_OLD_POLLS)
  },
  watch: {
    triggerOldPollResetBool () {
      if (this.triggerOldPollResetBool) {
        if (this.triggerOldPollInfiniteBool) {
          this.page = 1
          this.limit = 10
          this.$store.commit(types.RESET_OLD_POLLS)
          this.$refs.oldPollsLoading.$emit('$InfiniteLoading:reset')
        }
        this.$emit('disableTriggerOldPollResetBool')
      }
    }
  },
  methods: {
    onInfinite ($state) {
      this.receivedOldPollsInfiniteLoading(this.params($state))
      this.page++
    },
    params ($state) {
      return {
        searchParams: {
          p_page: this.page,
          p_limit: this.limit
        },
        $state: $state,
        triggerInfinite: this.triggerInfinite
      }
    },
    triggerInfinite ({ length, $state }) {
      if (length > 0) {
        $state.loaded()
      } else {
        $state.complete()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// oldPoll.vue?1c630002